import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BhAssignmentsLabelBuilderComponent } from './bh-assignments-label-builder.component';
import {BhTooltipModule} from "../bh-tooltip/bh-tooltip.module";


@NgModule({
  declarations: [BhAssignmentsLabelBuilderComponent],
  exports: [BhAssignmentsLabelBuilderComponent],
  imports: [CommonModule, BhTooltipModule],
})
export class BhAssignmentsLabelBuilderModule {}
